__turbopack_context__.v({
  "buttons-container": "styles-module-scss-module__7FNY1a__buttons-container",
  "buttons-container-outer": "styles-module-scss-module__7FNY1a__buttons-container-outer",
});
